import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconImage",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, f, _, e) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--image"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Image",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7ZM2.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h.293L7.19 5.603a1.5 1.5 0 0 1 2.12 0l.69.69V2.5a.5.5 0 0 0-.5-.5h-7ZM10 9.5a.5.5 0 0 1-.5.5H4.207l3.69-3.69a.5.5 0 0 1 .707 0L10 7.708V9.5Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ s(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=image.js.map
